import React, { FC } from "react";
import { TextField } from "@mui/material";
import { Control, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { CreateUpdateEntityFormValues } from "../../EntityEditor";

interface CompanyType {
  control: Control<CreateUpdateEntityFormValues>;
}

const CompanyType: FC<CompanyType> = ({ control }) => {
  const { t } = useTranslation();

  return (
    <Controller
      control={control}
      name="name"
      render={({
        field: { onBlur, onChange, name, value },
        fieldState: { error },
      }): React.ReactElement => (
        <TextField
          {...{ onBlur, onChange, name, value }}
          fullWidth
          type="text"
          label={t("entitiesManagement.entityEditor.entityName")}
          helperText={error?.message}
          error={Boolean(error)}
        />
      )}
    />
  );
};

export default CompanyType;
